import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { BookingDialog, openBooking } from "./BookingDialog";

const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

// Shared public header for the home page and the programme page
export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    const t = setTimeout(() => scrollToId(hash.slice(1)), 350);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  const go = (path, id) => {
    setOpen(false);
    if (pathname === path) {
      id ? scrollToId(id) : window.scrollTo({ top: 0, behavior: "smooth" });
      if (id) window.history.replaceState({}, "", `${path}#${id}`);
    } else navigate(id ? `${path}#${id}` : path);
  };

  const links = [
    { label: "Home", onClick: () => go("/"), testid: "nav-home" },
    { label: "Our Services", onClick: () => go("/", "platform"), testid: "nav-services" },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-lg border-b border-stone-100 ${open ? "bg-white" : "bg-white/95"}`} data-testid="header">
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12">
        <nav className="flex items-center justify-between h-16">
          <Link to="/" onClick={() => go("/")} className="flex items-center gap-2" data-testid="logo-link">
            <img src="/platemind-logo-new.png" alt="PlateMind" className="h-8 w-auto" />
          </Link>
          <div className="hidden lg:flex items-center gap-7">
            {links.map(l => (
              <button key={l.label} onClick={l.onClick} className="text-sm font-medium text-stone-500 hover:text-stone-900 transition-colors" data-testid={l.testid}>{l.label}</button>
            ))}
            <Button onClick={() => { setOpen(false); openBooking(); }} className="bg-[#FF7A00] hover:bg-[#E56E00] text-white rounded-full px-5 h-9 text-sm font-semibold" data-testid="nav-book">Book a Consultation</Button>
          </div>
          <button className="lg:hidden p-2 -mr-2" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="mobile-menu-btn">
            <div className="space-y-1.5">
              <span className={`block w-5 h-0.5 bg-stone-800 transition-all duration-300 ${open ? "rotate-45 translate-y-[7px]" : ""}`} />
              <span className={`block w-5 h-0.5 bg-stone-800 transition-all duration-300 ${open ? "opacity-0" : ""}`} />
              <span className={`block w-5 h-0.5 bg-stone-800 transition-all duration-300 ${open ? "-rotate-45 -translate-y-[7px]" : ""}`} />
            </div>
          </button>
        </nav>
        {open && (
          <div className="lg:hidden pb-5 pt-3 space-y-1 border-t border-stone-100 animate-fade-in">
            {links.map(l => <button key={l.label} onClick={l.onClick} className="block w-full text-left py-2.5 text-sm font-medium text-stone-600" data-testid={`m-${l.testid}`}>{l.label}</button>)}
            <button onClick={() => { setOpen(false); openBooking(); }} className="block w-full text-left py-2.5 text-sm font-semibold text-[#FF7A00]" data-testid="m-nav-book">Book a Consultation</button>
          </div>
        )}
      </div>
      <BookingDialog />
    </header>
  );
};
